import { Pagination, Popconfirm, Switch, Table} from 'antd';
import moment from 'moment';
import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { APPLICATION_ID, authFeatureConstants, COMMON_DATE_FORMAT, INVENTORY_MESSAGE_CONSTANTS, PAGE_QUERY_PARAM, StatusFilterType } from '../../../../shared/constants/commonConstants';
import { INVENTORY_SAVE_HEALTHCHECK } from '../../../../shared/constants/urlEndPoints';
import { base64UrlEncode, canActivate, error, extractSecondLevelBaseUrl, formatPrice, success } from './../../../../utils/utility';
import SendRequest from './../../../../shared/services/sendRequest.service';
import { Package } from '../../../../shared/models/packageDetail.model';
import { Consultation, PackageDetailBase, Test } from '../../../../shared/models/healthcheck.model';
import './HealthCheckList.less';
import { ReactComponent as ApprovedIcon } from '../../../../assets/images/svg/i_approved.svg';
import { ReactComponent as PendingIcon } from '../../../../assets/images/svg/i_pending.svg';
import { ReactComponent as RejectedIcon } from '../../../../assets/images/svg/i_rejected.svg';

const HealthCheckList = ({ match: { path }, packageItems, currentPage, totalRecords, onPaginationEvent }: any):
  ReactElement => {
  const data = [] as any;
  const history = useHistory();
  const [packageList, setPackageList] = useState(null as any);
  const [totalRecord, setTotalRecord] = useState(totalRecords);
  const isAuthrized = canActivate(authFeatureConstants.EDIT_HEALTH_CHECK_PACKAGES);
  useEffect((): void => {
    setPackageList(packageItems);
    setTotalRecord(totalRecords);
  }, [packageItems]);

  const rowClick = (record: any): any => {
    history.push(extractSecondLevelBaseUrl(path) +
      '/healthcheck-package-detail/' + base64UrlEncode(record.key) + PAGE_QUERY_PARAM + currentPage);
  };

  const onChangeSwitch = (value: any, record: any): any => {
    let Pdata = packageList ? [...packageList] : [];
    Pdata = Pdata?.filter((item: any): any => item.id === record.key);
    if (Pdata) {
      Pdata[0].isActive = !record.Active;
      Pdata[0].isApproved = false;
      onSavePackage(Pdata);
    }
  };

  const onSavePackage = async (PData: any): Promise<void> => {
    const packageD = PData[0] as Package;
    const testArray = [] as any;
    const consultationArray = [] as any;
    if (packageD.investigations) {
      packageD.investigations.map((item: any): void => {
        const investigation: Test = {
          investigationId: item.id,
          departmentId: item.groupId,
          isActive: item.isActive,
        };
        testArray.push(investigation);
      });
    }

    if (packageD.consultations) {
      packageD.consultations.map((item: any): void => {
        const consul: Consultation = {
          consultationId: item.id,
          isActive: item.isActive,
        };
        consultationArray.push(consul);
      });
    }

    const packageDetails: PackageDetailBase = {
      id: packageD.id,
      isActive: packageD.isActive,
      profileId: packageD.profileId,
      statusName: packageD.statusName,
      package: {
        description: packageD.description,
        discountedPrice: packageD.discountedPrice,
        gender: packageD.gender,
        maxAge: packageD.maxAge,
        minAge: packageD.minAge,
        name: packageD.packageName,
        price: packageD.price,
      },
      tests: testArray,
      consultations: consultationArray,
      specificInstructions: packageD.specificInstructions ? packageD.specificInstructions : [],
      generalInstructions: packageD.generalInstructions ? packageD.generalInstructions : [],
    };
    const payload = {
      applicationId: APPLICATION_ID,
      packageDetails: [packageDetails],
    };
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + INVENTORY_SAVE_HEALTHCHECK;
    const response: any = await SendRequest.instance.post(url, payload);
    if (response && response.isSuccess) {
      const pitems = packageList ? [...packageList] : [];
      pitems.forEach((item: any): any => {
        if (item.id === packageD.id) {
          item.isActive = packageD.isActive;
          item.statusName = StatusFilterType.isSubmit;
        }
      });
      setPackageList(pitems);
      success(`Package ${packageD && packageD.isActive ? 'enabled ' : 'disabled '} successfully`);
    } else if (response && response.errorMessage) {
      error(response.errorMessage);
    } else {
      error(INVENTORY_MESSAGE_CONSTANTS.packageSaveFail);
    }
    return;
  };

  const columns = [
    {
      title: 'Active',
      dataIndex: 'Active',
      key: 'active',
      render: (e: any, record: any): any => (
        <div onClick={(event: any): any => event.stopPropagation()} >
          <Popconfirm
            disabled={!isAuthrized}
            title={`Do you want to  ${record?.Active ? 'stop ' : 'enable '} appointments ?`}
            onConfirm={(value: any): any => onChangeSwitch(value, record)}
            okText="Yes"
            cancelText="No"
          >
            <Switch
              disabled={!isAuthrized}
              size="small"
              checked={record?.Active}
            />
          </Popconfirm>
        </div >
      ),
    },
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'name',
      className: 'mouse-pointer',
    },
    {
      title: 'Age Range',
      dataIndex: 'AgeRange',
      key: 'agerange',
      render: (e: any, record: any): any => (
        <p style={{ width: 100 }} >{record.AgeRange} </p>
      ),
    },
    {
      title: 'Price',
      dataIndex: 'Price',
      key: 'price',
      render: (e: any, record: any): any => (
        <p style={{ width: 100 }} >{record.Price} </p>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'Status',
      key: 'status',
      render: (text: any, record: any): ReactNode => {
        switch (record.Status) {
          case StatusFilterType.isApproved:
            return <div className="status verified" style={{ width: 100 }}>
              <ApprovedIcon className="fill-approved v-align-sub" /> Verified
            </div>;
          case StatusFilterType.isSubmit:
            return <div className="status pending" style={{ width: 100 }}>
              <PendingIcon className="fill-pending v-align-sub" /> Pending
            </div>;
          case StatusFilterType.isRejected:
            return <div className="status rejected" style={{ width: 100 }}>
              <RejectedIcon className="fill-rejected v-align-sub" /> Rejected
            </div>;
          default:
            return <div className="status pending" style={{ width: 100 }}>
              <PendingIcon className="fill-approved v-align-sub" /> Pending
            </div>;
        }
      },
    },
    {
      title: 'Last Updated',
      dataIndex: 'LastUpdated',
      key: 'lastupdated',
      render: (e: any, record: any): any => (
        <p style={{ width: 100 }} >{record.LastUpdated} </p>
      ),
    },
  ];
  if (packageList) {
    packageList.map((item: any): any => (
      data.push({
        key: item.id,
        Active: item.isActive,
        Name: item.packageName,
        AgeRange: item.minAge + ' - ' + item.maxAge,
        Price: formatPrice(item.price, false),
        Status: item.statusName,
        LastUpdated: moment(item.modifiedOn).format(COMMON_DATE_FORMAT),
      })
    ));
  }

  return (
    <div>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        onRow={(record: any, rowIndex: any): any => {
          return {
            onClick: (event: any): any => { rowClick(record); },
          };
        }}
      />
      {(data && data.length > 0 && totalRecord) &&
          <Pagination
            defaultPageSize={10}
            defaultCurrent={currentPage}
            total={totalRecord} onChange={(page: number, pagesize: any): any => onPaginationEvent(page, pagesize)}
            className="mt-md text-center" />
      }
    </div>
  );
};

export default HealthCheckList;
